export default __webpack_public_path__ + "static/media/output.2dcf89df.webm";